if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      if (this.form.querySelector('[name="id"]')) this.form.querySelector('[name="id"]').disabled = false;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      this.multi_item_request = false;
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      const submitter = evt.submitter || this.submitButton;
      if (submitter && submitter.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      if (submitter) {
        submitter.setAttribute('aria-disabled', true);
        submitter.classList.add('loading');
      }
      const loadingOverlay = (submitter && submitter.querySelector?.('.loading-overlay')) || this.querySelector('.loading-overlay');
      if (loadingOverlay) loadingOverlay.classList.remove('hidden');

      // Upsell items handled only in JS
      const upsell_ids_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-id`);
      const upsell_quantities_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-quantity`);
      let upsell_items = [];

      if (upsell_ids_nodes.length !== 0) {
        const upsell_ids = Array.from(upsell_ids_nodes).map(input => parseInt(input.value));
        const upsell_quantities = Array.from(upsell_quantities_nodes).map(input => parseInt(input.value));
        upsell_items = upsell_ids.map((id, index) => ({'id': id,'quantity': upsell_quantities[index]})).filter(item => item.quantity !== 0);
      }

      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        }
      }

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);

      // If upsell items added refactor FormData
      if (upsell_items.length > 0) {
        this.multi_item_request = true;
        const items = upsell_items;
        const id = parseInt(formData.get('id'));
        const quantity = parseInt(formData.get('quantity')) || 1;
        const the_product_item = { 'id': id, 'quantity': quantity }

        items.push(the_product_item);
        const itemsData = { 'items': items };

        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(itemsData);
      } else {
        this.multi_item_request = false;
        config.body = formData;
      }

      try {
        const res = await fetch(routes.cart_add_url + '.js', config)
        const json = await res.json();

        if (res.status !== 200) throw new Error(json.description);

        const addedItems = [];
        const sourceItems = Array.isArray(json?.items)
          ? json.items
          : Array.isArray(json)
            ? json
            : json && json.id
              ? [json]
              : [];

        const formProductId = this.form.closest('[data-product-id]')?.dataset?.productId;
        sourceItems.forEach((item) => {
          addedItems.push({
            variantId: item.variant_id,
            productId: item.product_id || formProductId,
            quantity: item.quantity || 1,
            title: item.title
          });
        });

        const event = new CustomEvent('ajaxProduct:added', { detail: { items: addedItems } });
        document.dispatchEvent(event);

        // Cart drawer behavior: always open or never → pulse blip when never
        try {
          const headerEl = document.getElementById('MainHeader');
          const behavior = headerEl ? headerEl.getAttribute('data-cart-open-behavior') : 'always';

          if (behavior === 'always') {
            // Open drawer-cart if present
            const drawer = document.getElementById('drawer-cart');
            if (drawer && typeof Woolman !== 'undefined' && Woolman.ModalsAndDrawers) {
              Woolman.ModalsAndDrawers.showModalOrDrawer('drawer-cart');
            }
          }
        } catch (e) {
          // no-op
        }
      } catch(error) {
        this.handleErrorMessage(error);
        console.error(error);
      }

      if (submitter) {
        submitter.classList.remove('loading');
        submitter.removeAttribute('aria-disabled');
      }
      if (loadingOverlay) loadingOverlay.classList.add('hidden');
      this.resetQuantityInput();
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || document.querySelector(`.product-form__error-message-wrapper[form="${this.form.getAttribute('id')}"]`)
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    resetQuantityInput() {
      const hidden_quantity_input = document.querySelector('[type=hidden][name=quantity]');
      if (hidden_quantity_input) {
        hidden_quantity_input.value = 1;
      }
    }
  });
}

class AddMultiplier extends HTMLElement {
  constructor() {
    super();

    const multiplyButton = this.querySelector('button');
    this.submitEvent = new SubmitEvent("submit", { submitter: multiplyButton });
    this.multiplyBy = parseInt(this.querySelector('[name=multiplied-quantity]').value);
    this.productForm = this.closest('product-form').querySelector('form');
    const formId = this.productForm.getAttribute('id');
    this.quantity_input = document.querySelector(`[name=quantity][form=${ formId }]`);
    multiplyButton.addEventListener('click', this.submitProductForm.bind(this));
  }

  submitProductForm() {
    this.quantity_input.value = this.multiplyBy;
    this.productForm.dispatchEvent(this.submitEvent);
  }
}
customElements.define("add-multiplier", AddMultiplier);
